const KEY = "YS_MEDIA_DEBUG";
export const MEDIA_DEBUG =
  (typeof localStorage !== "undefined" && localStorage.getItem(KEY) === "1") ||
  import.meta.env?.DEV === true;

export function mlog(...args: any[]) {
  if (MEDIA_DEBUG) console.debug("[media]", ...args);
}
export function mwarn(...args: any[]) {
  if (MEDIA_DEBUG) console.warn("[media]", ...args);
}
export function minfo(...args: any[]) {
  if (MEDIA_DEBUG) console.info("[media]", ...args);
}
